import { getJSON } from './basic-functions';
import { getCookie } from './cookies';

export async function initSessionData() {
  const token = getCookie('session_token');
  const jsonLang = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
  const jsonURL = `/${jsonLang}/json/session-data.json${token ? `?v=${token}` : ''}`;

  const response = await getJSON(jsonURL);
  if (!response?.data) return;
  updateSession(response.data);
}

function initSessionControl(status) {
  const getClassName = (status) => (status ? 'js-loggedin' : 'js-anonymous');
  if (localStorage.hasOwnProperty('ec_performance')) {
    console.log('Class: ', getClassName(status));
  }
  /*const sessionControlList = document.querySelectorAll(".js-login-control");
  for (const el of sessionControlList) {
    el.classList.add(getClassName(status));
    el.classList.remove(getClassName(!status));
  }*/
}

async function updateSession(data) {
  const replaceKeys = (map, mainKey) => {
    for (const keys of map) {
      if (Array.isArray(keys[1]) && keys[0] !== 'profile') {
        replaceKeys(keys[1], keys[0]);
        continue;
      }
      window[keys[1]] = mainKey ? data[mainKey][keys[0]] : data[keys[0]];
    }
  };

  const mapKeys = [
    ['product_type', '_CMS_PRODUCT_TYPE'],
    ['domain', '_CMS_USER_DOMAIN'],
    ['language', '_CMS_LANGUAGE'],
    ['timezone', '_CMS_TIMEZONE'],
    ['country', '_CMS_USERIP'],
    ['locale', '_CMS_LOCALE'],
    ['language', '_LANG'],
    [
      'version',
      [
        ['terms', '_TERMS_VERSION'],
        ['api', 'apiVersion']
      ]
    ],
    [
      'path',
      [
        ['terms_and_conditions', '_CMS_TERMS_AND_CONDITIONS_URL'],
        ['privacy_policy', '_CMS_PRIVACY_POLICY_URL'],
        ['terms_changes', '_CMS_TERMS_CHANGES_URL'],
        ['lottery_image', '_LOTTERY_IMAGE_PATH'],
        ['withdraw', '_CMS_WITHDRAWAL_PAGE_URL'],
        ['promo', '_CMS_REGISTRATION_PROMO_URL'],
        ['resp_gaming', '_CMS_RESP_GAMING_URL'],
        ['deposit', '_CMS_DEPOSIT_PAGE_URL'],
        ['support', '_CMS_SUPPORT_URL']
      ]
    ],
    [
      'user',
      [
        ['session', '_CMS_USER_SESSION_ACTIVE'],
        ['currency', '_CMS_USER_CURRENCY'],
        ['profile', '_CMS_USER_PROFILE'],
        ['no_dep', '_CMS_USER_NO_DEP']
      ]
    ]
  ];
  initSessionControl(data?.user?.session == '1');
  replaceKeys(mapKeys);
}

initSessionData();
